import React from "react";
import { Container, Box, Typography } from "@mui/material";
import about1 from "../assets/about1.png";
import about2 from "../assets/about2.png";

const aboutData = {
  title: "About Indian Book House",
  subtitle: "Where Every Genre, Every Author, Every Book Finds a Home",
  left: [
    "In the Great Green Room, there was a telephone... and a little bunny who sparked a lifelong love for stories. Just like Margaret Wise Brown’s ‘Goodnight Moon’, we at Indian Book House, began with a simple tale – a tale of love for books.",
    "Our story resonates with the journey of Liesel Meminger in Markus Zusak’s ‘The Book Thief’. Just as she discovered the captivating world of books amidst turmoil, so did we. We promised to deliver an universe of stories to every reader’s doorstep.",
    "Fast-forward to today, and the Indian Book House community is a robust 300000+ followers strong on Instagram Indian Book House. Each follower is a testament to our shared love for books. Much like the magical creatures in J K Rowling’s ‘Fantastic Beasts’, each follower is unique, contributing to our diverse and vibrant bibliophile’s paradise.",
    "Just like ‘The Little Prince’ by Antoine De-Saint Exupéry, we believed we could make every genre, every author, every book accessible to all. And we did. Be it the mysterious codes in ‘The Da Vinci Code’ by Dan Brown or the gripping narratives of ‘How To Kill a Mockingbird’ by Harper Lee, we’ve got you covered."
  ],
  leftImg: about1,
  right: [
    "Fast-forward to today, and the Indian Book House community is about to hit 30,000+ followers strong! In an Instagram posturing Indian Book House, each follower is a testament to our shared love for books. Much like the magical creatures in J.K Rowling’s ‘Fantastic Beasts’, each follower is unique, contributing to our diverse and vibrant bibliophile’s paradise.",
    "Just like ‘The Little Prince’ by Antoine De-Saint Exupéry, we believe reading can make every genre, every author, every book accessible to all. And we did! Be it the mysterious codes in ‘The Da Vinci Code’ by Dan Brown or the gripping narratives of ‘How To Kill a Mockingbird’ by Harper Lee, we’ve got you covered.",
    "As we grew, so did our library. Each book, each reader added a new chapter to our story. Together, we’ve built not just a bookstore, but a library. A library reminiscent of the expansive world in J.R.R Tolkien’s ‘Lord of the Rings’, filled with an endless array of books, waiting to be discovered.",
    "But we’re not stopping here. We’re on a quest, much like Bella’s in Stephenie Meyer’s ‘Twilight Series’, to make Indian Book House the library you truly deserve. A library that is not just a collection of books but a community of readers, a hub of stories, a home for every bibliophile."
  ],
  rightImg: about2,
  quote:
     "So, step into the magical world of Indian Book House. Immerse yourself in the passionate tales of ‘Fifty Shades of Grey Trilogy’ by E.L James, lose yourself in the mysteries of ‘It Ends with Us’ by Colleen Hoover, find love in the pages of ‘A Little Life’ by Hana Yanagihara. Because, as Albus Dumbledore once said, “Words are, in my not-so-humble opinion, our most inexhaustible source of magic.”"
};

const Aboutus = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4, px: { xs: 1, sm: 2, md: 4 } }}>
      <Typography variant="h6" fontSize={'24px'} fontWeight={500} mb={{xs: 2, md: 5}}>
        {aboutData.title}
      </Typography>
      

      {/* Row 1: Text left, Image right */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
          gap: { xs: 3, md: 2 },
          alignItems: "Center",
          mb: 2,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
        variant="h3"
        fontWeight={500}
        mb={3}
       
      >
        {aboutData.subtitle}
      </Typography>
          {aboutData.left.map((text, idx) => (
            <Typography
              key={idx}
              sx={{
                fontSize: '16px',
                fontWeight: 400,
                color: "#222",
                mb: 2,
                gap: 1.5,
                textAlign: "justify"
              }}
            >
              {text}
            </Typography>
          ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "flex-end" },
           
            minWidth: 0,
            mt: { xs: 2, md: 0 },
          }}
        >
          <Box
            component="img"
            src={aboutData.leftImg}
            alt="about1"
             sx={{
              width: { xs: "100vw", sm: "100%", md: "100%" },
              maxWidth: { xs: "100%", sm: 322, md: 322 },
              height: { xs: 200, sm: 260, md: 372 },
              borderRadius: 2,
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
      </Box>

      {/* Row 2: Image left, Text right */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 3, md: 4 },
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "flex-start" },
        
            minWidth: 0,
            mb: { xs: 2, md: 0 },
          }}
        >
          <Box
            component="img"
            src={aboutData.rightImg}
            alt="about2"
            sx={{
              width: { xs: "100vw", sm: "100%", md: "100%" },
              maxWidth: { xs: "100%", sm: 322, md: 322 },
              height: { xs: 200, sm: 260, md: 372 },
              borderRadius: 2,
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          {aboutData.right.map((text, idx) => (
            <Typography
              key={idx}
              variant="body1"
              sx={{
                fontSize: '16px',
                fontWeight: 400,
                color: "#222",
                mb: idx === aboutData.right.length - 1 ? 0 : 1.5,
                textAlign: "justify"
              }}
            >
              {text}
            </Typography>
          ))}
        </Box>
      </Box>

      {/* Quote Section */}
      <Box
        sx={{
          bgcolor: "rgba(255, 162, 0, 0.43)",
          borderRadius: 2,
          textAlign: "center",
          pt: { xs: 2, md: 5 },
          pb: { xs: 2, md: 5 },
          px: { xs: 2, sm: 4, md: 10 },
          mt: 2,
          mb: 2,
        }}
      >
        <Typography sx={{ fontSize: 15, color: "#000" }}>
          {aboutData.quote}
        </Typography>
      </Box>
    </Container>
  );
};

export default Aboutus;